<div nz-row *ngIf="viewGrid">
    <div nz-col nzSpan="6">
        <span class="pageTitle">Report</span>
    </div>
    <div nz-col nzSpan="8">

    </div>
    <div nz-col nzSpan="10">
    </div>
</div>
<div *ngIf="!this.currentUser.Is_Partner && viewGrid">
    <div class="create-query-container">
        <form [formGroup]="reportForm" class="ant-advanced-search-form">

            <div class="row form-group">
                <div class="col-md-2">
                    <label>Reference Number</label>
                </div>
                <div class="col-md-3">
                    <input nz-input formControlName="RequestNumber" maxlength="25" type="text" class="form-control" />
                </div>
                <div class="col-md-3 col-md-push-1">
                    <label>Subject</label>
                </div>
                <div class="col-md-3">
                    <input nz-input formControlName="Subject" maxlength="80" type="text" class="form-control" />
                </div>
            </div>
            <div class="row form-group">
                <div class="col-md-2">
                    <label>Requestor Name</label>
                </div>
                <div class="col-md-3">
                    <!-- <ng-multiselect-dropdown [placeholder]="'Select User'" [data]="requestorNames"
                formControlName="RequestorName" [settings]="dropdownSettings">
            </ng-multiselect-dropdown> -->
                    <nz-select id="RequestorName" formControlName="RequestorName" nzMode="multiple"
                        [nzPlaceHolder]="loadingText" nzAllowClear="true" [nzLoading]="!isMasterDataLoaded"
                        [nzDisabled]="!isMasterDataLoaded" style="width: 100%;">
                        <nz-option *ngFor="let item of requestorNames" [nzLabel]="item.item_text"
                            [nzValue]="item.item_id"></nz-option>
                    </nz-select>
                </div>
                <div class="col-md-3 col-md-push-1">
                    <label>Requestor Email</label>
                </div>
                <div class="col-md-3">
                    <!-- <ng-multiselect-dropdown [placeholder]="'Select Email'" [data]="requestorEmails"
                formControlName="RequestorEmail" [settings]="dropdownSettings">
            </ng-multiselect-dropdown> -->
                    <nz-select id="RequestorEmail" formControlName="RequestorEmail" nzMode="multiple"
                        [nzPlaceHolder]="loadingText" [nzLoading]="!isMasterDataLoaded"
                        [nzDisabled]="!isMasterDataLoaded" style="width: 100%;">
                        <nz-option *ngFor="let item of requestorEmails" [nzLabel]="item.item_text"
                            [nzValue]="item.item_id"></nz-option>
                    </nz-select>
                </div>
            </div>

            <div class="row form-group" [hidden]="isCollapse">
                <div class="col-md-2">
                    <label>Request Created By</label>
                </div>
                <div class="col-md-3">
                    <nz-select id="CreatedBy" formControlName="CreatedBy" nzMode="multiple"
                        [nzPlaceHolder]="loadingText" nzAllowClear="true" [nzLoading]="!isMasterDataLoaded"
                        [nzDisabled]="!isMasterDataLoaded" style="width: 100%;">
                        <nz-option *ngFor="let item of allUsers" [nzLabel]="item.User_Name??''"
                            [nzValue]="item.User_Code ?? '0'"></nz-option>
                    </nz-select>
                </div>
                <div class="col-md-3 col-md-push-1">
                    <label>Query Status</label>
                </div>
                <div class="col-md-3">
                    <nz-select id="RequestStatus" formControlName="RequestStatus" [nzPlaceHolder]="loadingText"
                        nzAllowClear="true" [nzLoading]="!isMasterDataLoaded" [nzDisabled]="!isMasterDataLoaded"
                        style="width: 100%;">
                        <nz-option *ngFor="let item of queryStatusMaster" [nzLabel]="item.Status_Name"
                            [nzValue]="item.Status_Code"></nz-option>
                    </nz-select>
                </div>
            </div>
            <div class="row form-group" [hidden]="isCollapse">
                <div class="col-md-2">
                    <label>Confidential</label>
                </div>
                <div class="col-md-3">
                    <nz-select class="form-control" formControlName="Confidential" style="width: 100%;"
                        nzAllowClear="true">
                        <nz-option nzLabel="All" nzValue="0"></nz-option>
                        <nz-option nzLabel="Yes" nzValue="1"></nz-option>
                        <nz-option nzLabel="No" nzValue="2"></nz-option>
                    </nz-select>
                </div>
                <div class="col-md-1"></div>
                <div class="col-md-2 col-md-push-1">
                    <label>Priority</label>
                </div>
                <div class="col-md-3">
                    <nz-select id="PriorityLevel" formControlName="PriorityLevel" [nzPlaceHolder]="loadingTextAll"
                        nzAllowClear="true" [nzLoading]="!isMasterDataLoaded" [nzDisabled]="!isMasterDataLoaded"
                        style="width: 100%;">
                        <nz-option *ngFor="let priorityLevel of priorityLevels" [nzValue]="priorityLevel"
                            [nzLabel]="priorityLevelMapping[priorityLevel]"></nz-option>
                    </nz-select>
                </div>
            </div>

            <div class="row form-group" [hidden]="isCollapse">
                <div class="col-md-2">
                    <label>Request Start Date</label>
                </div>
                <div class="col-md-3">
                    <nz-date-picker formControlName="ReqStartDt" [nzDisabled]="false" [nzFormat]="'dd-MMM-yyyy'"
                        [nzPlaceHolder]="'dd-MMM-yyyy'" style="width: 100%;"></nz-date-picker>

                </div>
                <div class="col-md-3 col-md-push-1">
                    <label>Request End Date</label>
                </div>
                <div class="col-md-3">
                    <nz-date-picker formControlName="ReqEndDt" [nzDisabled]="false" [nzFormat]="'dd-MMM-yyyy'"
                        [nzPlaceHolder]="'dd-MMM-yyyy'" style="width: 100%;"></nz-date-picker>
                </div>

            </div>
            <div class="row form-group" [hidden]="isCollapse">
                <div class="col-md-2">
                    <label>Company</label>
                </div>
                <div class="col-md-3">
                    <nz-select formControlName="Company" [nzPlaceHolder]="loadingTextAll" nzAllowClear="true"
                        [nzLoading]="!isMasterDataLoaded" [nzDisabled]="!isMasterDataLoaded" style="width: 100%;">
                        <nz-option *ngFor="let item of companyMaster" [nzValue]="item.Company_Code"
                            [nzLabel]="item.Company_Name"></nz-option>
                    </nz-select>
                </div>
                <div class="col-md-3 col-md-push-1">
                    <label>Block</label>
                </div>
                <div class="col-md-3">
                    <nz-select formControlName="Block" [nzPlaceHolder]="loadingTextAll" nzAllowClear="true"
                        [nzLoading]="!isMasterDataLoaded" [nzDisabled]="!isMasterDataLoaded" style="width: 100%;">
                        <nz-option *ngFor="let item of blockMaster" [nzValue]="item.Block_Code"
                            [nzLabel]="item.Block_Name"></nz-option>
                    </nz-select>
                </div>
            </div>
            <div class="row form-group" [hidden]="isCollapse">
                <div class="col-md-2">
                    <label>Department</label>
                </div>
                <div class="col-md-3">
                    <nz-select formControlName="Department" [nzPlaceHolder]="loadingTextAll" nzAllowClear="true"
                        (ngModelChange)="onDepartmentChange($event)" [nzLoading]="!isMasterDataLoaded"
                        [nzDisabled]="!isMasterDataLoaded" style="width: 100%;">
                        <nz-option *ngFor="let item of departmentMaster" [nzValue]="item.Department_Code"
                            [nzLabel]="item.Department_Name"></nz-option>
                    </nz-select>
                </div>
                <div class="col-md-3 col-md-push-1">
                    <label>Sub Department</label>
                </div>
                <div class="col-md-3">
                    <nz-select formControlName="SubDepartment" [nzPlaceHolder]="loadingTextAll" nzAllowClear="true"
                        [nzLoading]="!isMasterDataLoaded" [nzDisabled]="!isMasterDataLoaded" style="width: 100%;">
                        <nz-option *ngFor="let item of deptSubDeptMaster" [nzValue]="item.Sub_Dept_Code"
                            [nzLabel]="item.Sub_Dept_Name"></nz-option>
                    </nz-select>
                </div>
            </div>
            <div class="row form-group" [hidden]="isCollapse">
                <div class="col-md-2">
                    <label>Query Category</label>
                </div>
                <div class="col-md-3">
                    <nz-select formControlName="QueryCat" [nzPlaceHolder]="loadingTextAll" nzAllowClear="true"
                        (ngModelChange)="onQueryCategoryChange($event)" [nzLoading]="!isMasterDataLoaded"
                        [nzDisabled]="!isMasterDataLoaded" style="width: 100%;">
                        <nz-option *ngFor="let item of categoryMaster" [nzValue]="item.Cat_Code"
                            [nzLabel]="item.Desc"></nz-option>
                    </nz-select>
                </div>
                <div class="col-md-3 col-md-push-1">
                    <label>Query Sub Category</label>
                </div>
                <div class="col-md-3">
                    <nz-select formControlName="QuerySubCat" [nzPlaceHolder]="loadingTextAll" nzAllowClear="true"
                        [nzLoading]="!isMasterDataLoaded" [nzDisabled]="!isMasterDataLoaded" style="width: 100%;">
                        <nz-option *ngFor="let item of catSubCatMaster" [nzValue]="item.Sub_Cat_Code"
                            [nzLabel]="item.SubCatDesc"></nz-option>
                    </nz-select>
                </div>
            </div>
            <div class="row form-group" [hidden]="isCollapse">
                <div class="col-md-2">
                    <label>Letter Reference Number</label>
                </div>
                <div class="col-md-3">
                    <input nz-input formControlName="LetterRefNum" maxlength="25" type="text" class="form-control" />
                </div>
                <div class="col-md-3 col-md-push-1">
                    <label>Contract Number</label>
                </div>
                <div class="col-md-3">
                    <input nz-input formControlName="ContractNum" maxlength="25" type="text" class="form-control" />
                </div>
            </div>

            <div class="row form-group" [hidden]="isCollapse">
                <div class="col-md-2">
                    <label>Work Order Number</label>
                </div>
                <div class="col-md-3">
                    <input nz-input formControlName="WONum" maxlength="25" type="text" class="form-control" />
                </div>
                <div class="col-md-3 col-md-push-1">
                    <label>AFE Number</label>
                </div>
                <div class="col-md-3">
                    <input nz-input formControlName="AFENumber" maxlength="25" type="text" class="form-control" />
                </div>
            </div>
            <div class="row form-group" [hidden]="isCollapse">
                <div class="col-md-2">
                    <label>Company Restricted</label>
                </div>
                <div class="col-md-2">
                    <nz-select class="form-control" formControlName="CompanyRestricted" style="width: 100%;"
                        nzAllowClear="true">
                        <nz-option nzLabel="All" nzValue="0"></nz-option>
                        <nz-option nzLabel="Yes" nzValue="1"></nz-option>
                        <nz-option nzLabel="No" nzValue="2"></nz-option>
                    </nz-select>
                </div>
            </div>

            <div nz-row style="margin-top: 40px;">
                <div nz-col [nzSpan]="24" class="search-area">
                    <button nz-button [nzType]="'primary'" (click)="generateReport()">Generate Report</button>
                    <button nz-button (click)="resetFilter()">Reset Filter</button>
                    <button nz-button [nzType]="'link'" style="font-size: 12px; margin-left: 12px;"
                        (click)="toggleCollapse()">
                        {{isCollapse ? 'Show' : 'Hide'}} Advanced Search
                        <nz-icon [nzType]="isCollapse ? 'down' : 'up'" />
                    </button>
                </div>
            </div>

        </form>
    </div>
    <br />
    <div class="row form-group" *ngIf="viewReportDetails">
        <div class="button-container" nz-col nzSpan="24" style="display: flex; justify-content: flex-end; align-items: center; float: right;">
            <button nz-button [nzType]="'primary'" (click)="exportToExcel()" data-toggle="tooltip" data-placement="top"
                title="Click to export report data in excel">
                <!-- <span class="glyphicon glyphicon-export"></span> -->
                Export To Excel
            </button>
          </div>
        <div class="row col-md-12">
            
        </div>
        <div class="col-md-12">
            <nz-table #basicTable [nzData]="reportData" [nzBordered]="true" [nzSize]="'small'" [nzShowPagination]="true"
                [nzScroll]="{ x: '3900px',  y: '340px' }">
                <thead>
                    <tr>
                        <th class="thead text-center" nzLeft>Reference Number</th>
                        <th>Subject</th>
                        <th>Request Status</th>
                        <th>Requestor Name</th>
                        <th>Requestor Email</th>
                        <th>Priority</th>
                        <th>Confidential</th>
                        <th>Company</th>
                        <th>Request Date</th>
                        <th>Responded Date</th>
                        <th>Block</th>
                        <th>Department</th>
                        <th>Sub Deptartment</th>
                        <th>Company Restricted</th>
                        <th>Category</th>
                        <th>Sub Category</th>
                        <th>AFE Number</th>
                        <th>Letter Reference Number</th>
                        <th>Contract Number</th>
                        <th>Work Order Number</th>
                        <th>Due Date</th>
                        <th>Category Comments</th>
                        <th>Partner Comment</th>
                        <th>Resolution Comment</th>
                        <th>Delete Comment</th>
                        <th>Request Created By</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let query of basicTable.data">
                        <td class="text-center" nzLeft>
                            <a style="cursor: pointer;" (click)="showQueryDetails(query)">
                                <strong>{{query.QueryRequestNumber}}</strong></a>
                        </td>
                        <td class="text-center"><strong>{{query.Subject}}</strong></td>
                        <td class="text-center"><strong>{{query.QueryStatus}}</strong></td>
                        <td class="text-center">{{query.RequestorName}}</td>
                        <td class="text-center">{{query.RequestorEmail}}</td>
                        <td class="text-center">{{query.Priority}}</td>
                        <td class="text-center">{{query.Confidential ? 'Yes': 'No'}}</td>
                        <td class="text-center">{{query.Company}}</td>
                        <td class="text-center">{{query.RequestedDate | date:'dd-MMM-yyyy hh:mm:ss a' }}</td>
                        <td class="text-center">{{query.RespondedDate | date:'dd-MMM-yyyy hh:mm:ss a' }}</td>
                        <td class="text-center">{{query.Block}}</td>
                        <td class="text-center">{{query.Department}}</td>
                        <td class="text-center">{{query.SubDeptartment}}</td>
                        <td class="text-center">{{query.CompanyRestricted ? 'Yes': 'No'}}</td>
                        <td class="text-center">{{query.Category}}</td>
                        <td class="text-center">{{query.SubCategory}}</td>
                        <td class="text-center">{{query.AFENumber}}</td>
                        <td class="text-center">{{query.LetterReferenceNumber}}</td>
                        <td class="text-center">{{query.ContractNumber}}</td>
                        <td class="text-center">{{query.WorkOrderNumber}}</td>
                        <td class="text-center">{{query.QueryReqDueDate | date:'dd-MMM-yyyy hh:mm:ss a' }}</td>
                        <td style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">{{query.CategoryComments}}</td>
                        <td style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">{{query.PartnerComment}}</td>
                        <td style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">{{query.ResolutionComment}}</td>
                        <td style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">{{query.DeleteComment}}</td>

                        <td class="text-center">{{query.CreatedByUserName}}</td>
                    </tr>
                </tbody>
            </nz-table>
        </div>
    </div>
</div>

<div class="Layoutcontainer" *ngIf="!viewGrid">
    <br>
    <div class="row">
        <h4 style="text-align: left; margin-left:12px">Query Reference Number - {{queryReferenceNumber}}</h4>
    </div>
    <div *ngIf="queryDetail">
        <app-query-detail-info [queryDetail]="queryDetail" [requestStatus]="requestStatus"
            [partnerUserMaster]="partnerUserMaster" [CCSubDepartmentsMaster]="CCSubDepartmentsMaster"
            [Subject]="subject">
        </app-query-detail-info>
    </div>
    <br>
    <div class="row">
        <div class="col-md-3 col-md-push-2">
            <button (click)="redirectBack()" class="btn btn-primary">
                Back
            </button>
        </div>
    </div>
</div>